<template>
    <div ref="modalAccess" class="phone-modal with-nav" style="bottom: -600px;" :class="{ active: isAccessModalOpen }">
        <span class="modal-line"></span>
        <div class="modal-title-bar">
            <div class="icon-wrap">
                <RegisterIcon style="width: 27px; height: 27px;" class="icon register-icon" />
                <span>Create your profile</span>
            </div><!-- icon wrap -->
            <GreyCloseIcon @click="closeAccessModal" style="width: 31px; height: 31px;" class="icon close" />
        </div><!-- modal title bar -->
        <div class="modal-message-block wide">
            <ProfileIcon class="profile-icon" style="width: 50px; height: 50px;" />
            <h3>Please create a profile to access this area.</h3>
            <p>This app will always be free, but creating a profile will give you greater access to the app.</p>
        </div>
        <Button routeName="/create-profile" icon="RegisterIcon" class="btn btn-green btn-icon btn-icon-white btn-icon-small btn-icon-right" text="Okay, I'll create a profile"></Button>
        <Button @click.native="openLoginScreen" icon="LoginIcon" class="btn btn-slate btn-icon btn-icon-white btn-icon-small btn-icon-right" text="I already have a profile"></Button>
        <a @click="closeAccessModal()" class="text-link text-link-grey">I'll create a profile another time &raquo;</a>
    </div><!-- modal -->
</template>

<script>
import RegisterIcon from '@/assets/register.svg';
import GreyCloseIcon from '@/assets/close-grey.svg';
import ProfileIcon from '@/assets/profile.svg';
import Button from '@/components/Button.vue';
export default {
    name: 'AccessModal',
    components: {
        RegisterIcon,
        GreyCloseIcon,
        ProfileIcon,
        Button
    },
    computed: {
        isAccessModalOpen () {
            return this.$store.state.isAccessModalOpen;
        }
    },
    methods: {
        closeAccessModal () {
            this.$store.state.isAccessModalOpen = false;
        },
        openLoginScreen () {
            this.$router.push({ name: 'Home', params: { showLoginModal: true } });
        }
    }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/_variables.scss";
</style>
